<template>
    <div class="my-outbox" ref='outbox' @mouseenter="stoprun" @mouseleave="startrun">
        <div class="my-inbox" ref='movebox'>
            <div class="my-listbox " v-for="(item,index) in sendVal" :key='index'>
                <div class="my-content hiddentext" @click="gotodetail(item)">{{retuloction(item.userloctionstr)}}{{item.title}}</div>
            </div>
            <div class="my-listbox" v-for="(item,index) in sendVal" :key='(index+1)*100' >
                <div class="my-content hiddentext" @click="gotodetail(item)">{{retuloction(item.userloctionstr)}}{{item.title}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {routerGoNewpage} from "@/utils/index"
 export default {
        name:'my-marquee-top',
        props:{
            sendVal:Array
        },
        data() {
            return {
                isShow:true,
                run:true,
            }
        },
        created(){

        },
        watch:{
        },
        methods:{
            retuloction(str){
                if(str != null ){
                    return str.split(",")[0]+"：";
                }
            },
            gotodetail(item){
                if(item.type && item.type == 2){
                    routerGoNewpage('/demand_detail',{id:item.id,type:2})
                }else{
                    routerGoNewpage('/demand_detail',{id:item.id,type:1})
                }
            },
            init(){
                var _this=this;
                var moveTarget = this.$refs.movebox;
                var outbox = this.$refs.outbox;
                var initTop = 0;
                setInterval(function(){
                if(_this.run){
                    initTop ++;
                    if(initTop >= moveTarget.offsetHeight / 2 ){
                        initTop = 0;
                    }
                    // moveTarget.style = 'transform: translateY(-'+ initTop +'px)';
                    moveTarget.style.transform ='translateY(-'+ initTop +'px) scale(1.05) translateZ(0)';
                }
               },50)
            },
            stoprun(){
                this.run=false;
            },
            startrun(){
                 this.run=true;
            }
        },
        mounted(){
          this.init()
        },
}
</script>

<style lang="less" scoped>

.my-outbox{
    //color: #FEE7B1;
    height:93px;
    margin: 1px;
    //background: #FEE7B1;
    overflow: hidden;
    border-left: 1px solid #eeeeee;
    border-bottom: 1px solid #eeeeee;
    border-right: 1px solid #eeeeee;
    .my-inbox{
        margin: 0 45px;
        .my-listbox{
            padding: 12px 0;
            font-size: 18px;
            border-bottom: 1px solid #eeeeee;
            .my-content{
                text-align: justify;
                word-break: break-all;
                font-size: 14px;
                color: #53565D;
                 -webkit-backface-visibility: hidden;
                backface-visibility: hidden;
            }
            .hiddentext{
                width:150px;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
                cursor: pointer;
            }
            .hiddentext:hover{
              color: #ff7302;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/marquee.vue